<script setup lang="ts">
import { SignIn } from '@clerk/vue';
import Layout from '../components/layout/Layout.vue';
import StellarBackground from '../components/animations/StellarBackground.vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const redirectPath = route.query.redirect as string || '/';





</script>

<template>
  <Layout>
    <div class="sign-in-wrapper">
      <StellarBackground/>
      <div class="sign-in-container">
        <SignIn :fallbackRedirectUrl="redirectPath"/>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.sign-in-wrapper {
  width: 100%;
  min-height: calc(100vh - 60px);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  overflow-x: hidden;
}

.sign-in-container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

@media (max-width: 768px) {
  .sign-in-container {
    padding: 0 1rem;
  }
}
</style>